import { render } from "./Votings.vue?vue&type=template&id=0b8d35e2"
import script from "./Votings.vue?vue&type=script&lang=js"
export * from "./Votings.vue?vue&type=script&lang=js"
script.render = render

export default script